import { Component } from '@angular/core';
import { SectionHeadingComponent } from '../../ui/section-heading/section-heading.component';

@Component({
  selector: 'app-formats',
  standalone: true,
  imports: [SectionHeadingComponent],
  templateUrl: './formats.component.html',
  styleUrl: './formats.component.scss',
})
export class FormatsComponent {}
